import { API_BASE_URL } from "../config/apiConfig"

/**
 * Send a contact message
 * @param {Object} messageData
 * @param {string} messageData.fullName
 * @param {string} messageData.email
 * @param {string} messageData.subject
 * @param {string} messageData.message
 * @param {string} messageData.recipientType - "admin" or "company"
 * @param {string} [messageData.companyName] - Required if recipientType is "company"
 */
export const sendContactMessage = async (messageData) => {
  const response = await fetch(`${API_BASE_URL}/contact-messages/public/send`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(messageData),
  })

  return response.json()
}




